import { motion } from "framer-motion";
import { Check, Users, ArrowRight } from "lucide-react";
import { Gallery } from "./Gallery";

const brl = (n) =>
  n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 0 });

export const Cabins = ({ cabins, onReserve }) => {
  return (
    <section id="chales" className="bg-brand-sand py-24 md:py-36" data-testid="cabins-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="text-xs md:text-sm uppercase tracking-[0.25em] font-bold text-brand-terracotta mb-4">
              Nossas acomodações
            </p>
            <h2 className="text-4xl md:text-6xl font-bold tracking-tighter leading-[0.95] text-brand-forest">
              Três refúgios,<br />uma mesma paz.
            </h2>
          </div>
          <p className="max-w-sm text-brand-ink/70 text-base leading-relaxed">
            Cada chalé foi pensado para uma experiência única — do romance a dois à
            celebração em família. Navegue pelas fotos com as setas.
          </p>
        </div>

        <div className="space-y-28">
          {cabins.map((cabin, idx) => (
            <motion.div
              key={cabin.id}
              id={`chale-${cabin.id}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className={`grid lg:grid-cols-12 gap-8 lg:gap-12 items-center ${
                idx % 2 === 1 ? "lg:[direction:rtl]" : ""
              }`}
            >
              <div className="lg:col-span-7 lg:[direction:ltr]">
                <Gallery images={cabin.images} name={cabin.name} testid={`gallery-${cabin.id}`} />
              </div>

              <div className="lg:col-span-5 lg:[direction:ltr]">
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-brand-terracotta text-sm font-bold tracking-[0.2em]">
                    0{idx + 1}
                  </span>
                  <span className="h-px w-12 bg-brand-forest/30" />
                  <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.15em] font-bold text-brand-forest/70">
                    <Users className="w-3.5 h-3.5" /> {cabin.capacity}
                  </span>
                </div>

                <h3 className="text-3xl md:text-4xl font-bold tracking-tight text-brand-forest mb-3">
                  {cabin.name}
                </h3>
                <p className="text-brand-terracotta font-bold text-sm uppercase tracking-[0.15em] mb-5">
                  {cabin.tagline}
                </p>
                <p className="text-brand-ink/75 leading-relaxed mb-6">
                  {cabin.description}
                </p>

                <div className="grid grid-cols-2 gap-x-4 gap-y-2 mb-8">
                  {cabin.features.slice(0, 8).map((f) => (
                    <div key={f} className="flex items-start gap-2 text-sm text-brand-ink/80">
                      <Check className="w-4 h-4 text-brand-forest-light mt-0.5 flex-shrink-0" />
                      <span>{f}</span>
                    </div>
                  ))}
                </div>

                <div className="flex items-center justify-between border-t border-brand-forest/20 pt-6">
                  <div>
                    <span className="block text-xs uppercase tracking-[0.15em] text-brand-ink/50 mb-1">
                      Diária a partir de
                    </span>
                    <span className="text-3xl font-bold text-brand-forest">
                      {brl(cabin.price)}
                    </span>
                  </div>
                  <button
                    data-testid={`cabin-reserve-${cabin.id}`}
                    onClick={() => onReserve(cabin.id)}
                    className="group inline-flex items-center gap-2 bg-brand-forest text-brand-cream px-7 py-4 text-[12px] uppercase tracking-[0.2em] font-bold hover:bg-brand-forest-light transition-colors duration-300"
                  >
                    Reservar
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
